const resource = {
    resource_identifier_in_use: 'Идентификатор API {{indicator}} уже используется',
    /** UNTRANSLATED */
    cannot_delete_management_api: 'Cannot delete Logto management API.',
};
export default Object.freeze(resource);
